import React from 'react'

function Predict_2048(original_state) {
    
    let get_random= ()=>{
        let a=Math.random();
        if(a>0.9)
            return 4;
        return 2;
    }
    let get_empty_pos=(arr)=>{
        let pos=[];
        for(let i=0;i<16;i++)
        {   
            if(arr[i]===0)
                pos.push(i);

        }
        return pos;
    }

    let evaluate_state_v5=(state)=>{
        //just a copy before changing every thing
        //v2 + cornered advantage + zero blocks
        let max_tile=0;
        let sum_tile=0;

        let score=0;
        for(let i=0;i<state.length;i++)
        {
            let ix=i%4;
            let iy=Math.floor(i/4);

            // score+=Math.pow(state[i],1.2)*(((ix+iy)/2)+1);
            // let val1=Math.pow(state[i],1.2);
            // score+=val1*(ix===3?2:ix===2?1.5:1);
         
            let val1=Math.pow(state[i],ix===3?4:ix===2?2.4:1.1);
            score+=val1;
            if(state[i]>max_tile)
                max_tile=state[i];
            sum_tile+=state[i];
        }

        let adj_score=0;

        let zero_adj_num=0;
        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i*4+j;
                if(state[ind]===state[ind+1])
                {
                    adj_score+=Math.pow(state[ind],1.3);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }

        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i+j*4;
                if(state[ind]===state[ind+4])
                {
                    adj_score+=Math.pow(state[ind],1.3);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }


        // if(zero_adj_num>4)
        // {
        //     // score=Math.pow(score,zero_adj_num);
        //     score=score*zero_adj_num/4;
        // }

        let avg_tile=sum_tile/16;
        let zero_score=Math.pow(max_tile,zero_adj_num/4);
        // let zero_score=Math.pow(avg_tile,zero_adj_num/4);

        score=score+adj_score+zero_score;

        return score;
    }

    let evaluate_state=(state)=>{
        //v2 + cornered advantage + zero blocks
        let max_tile=0;
        let sum_tile=0;

        let score=0;
        let numb_zero=0;
        for(let i=0;i<state.length;i++)
        {
            let ix=i%4;
            let iy=Math.floor(i/4);

            // score+=Math.pow(state[i],1.2)*(((ix+iy)/2)+1);
            // let val1=Math.pow(state[i],1.2);
            // score+=val1*(ix===3?2:ix===2?1.5:1);
            let pow_fact=1.2;
            // if(ix===3||iy===3)
            if(ix===3||ix===2)
                pow_fact=ix==3?1.8:1.5;
         
            let val1=Math.pow(state[i],pow_fact);
            score+=val1;
            if(state[i]>max_tile)
                max_tile=state[i];
            if(state[i]===0)
                numb_zero++;
            sum_tile+=state[i];
        }

        let adj_score=0;

        let zero_adj_num=0;
        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i*4+j;
                // if(state[ind]===state[ind+1]||state[ind]===2*state[ind+1]||state[ind]===0.5*state[ind+1])
                // if(state[ind]===state[ind+1]||state[ind]===2*state[ind+1])
                // {
                //     adj_score+=Math.pow(state[ind],1.1);
                //     if(state[ind]===0)
                //         zero_adj_num++;
                // }
                if(state[ind]===state[ind+1])
                {
                    adj_score+=Math.pow(state[ind],1.2);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
                else if(state[ind]===2*state[ind+1])
                {
                    adj_score+=Math.pow(state[ind],1.1);
                }
            }
        }

        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i+j*4;
                // if(state[ind]===state[ind+4]||state[ind]===2*state[ind+4]||state[ind]===0.5*state[ind+4])
                if(state[ind]===state[ind+4])
                {
                    adj_score+=Math.pow(state[ind],1.2);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
                else if(state[ind]===2*state[ind+4])
                {
                    adj_score+=Math.pow(state[ind],1.1);
                  
                }
            }
        }


        // if(zero_adj_num>4)
        // {
        //     // score=Math.pow(score,zero_adj_num);
        //     score=score*zero_adj_num/4;
        // }

        // let avg_tile=sum_tile/16;
        // let zero_score=Math.pow(max_tile,zero_adj_num/4);
        // let zero_score=Math.pow(avg_tile,zero_adj_num/4);

        let zero_score=1+numb_zero/16;
        score=score*zero_score;

        score=score+adj_score;

        return score;
    }

    
    let evaluate_state_v4=(state)=>{
        //this one actually did 2048, right sidee is katta powered and no zero bloacks did
        //v2 + cornered advantage + zero blocks
        let score=0;
        for(let i=0;i<state.length;i++)
        {
            let ix=i%4;
            let iy=Math.floor(i/4);

            // score+=Math.pow(state[i],1.2)*(((ix+iy)/2)+1);
            // let val1=Math.pow(state[i],1.2);
            // score+=val1*(ix===3?2:ix===2?1.5:1);
         
            let val1=Math.pow(state[i],ix===3?4:ix===2?2.4:1.1);
            score+=val1;
        }

        let adj_score=0;

        let zero_adj_num=0;
        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i*4+j;
                if(state[ind]===state[ind+1])
                {
                    adj_score+=Math.pow(state[ind],1.3);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }

        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i+j*4;
                if(state[ind]===state[ind+4])
                {
                    adj_score+=Math.pow(state[ind],1.3);
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }


        // if(zero_adj_num>0)
        // {
        //     // score=Math.pow(score,zero_adj_num);
        //     score=score*Math.pow(1.2,zero_adj_num);

        // }

        score=score+adj_score;

        return score;
    }

    let evaluate_state_v3=(state)=>{
        //v2 + cornered advantage + zero blocks
        let score=0;
        for(let i=0;i<state.length;i++)
        {
            let ix=i%4;
            let iy=Math.floor(i/4);

            // score+=Math.pow(state[i],1.2)*(((ix+iy)/2)+1);
            // let val1=Math.pow(state[i],1.2);
            // score+=val1*(ix===3?2:ix===2?1.5:1);
         
            let val1=Math.pow(state[i],ix===3?4:ix===2?2.4:1.1);
            score+=val1;
        }

        let adj_score=0;

        let zero_adj_num=0;
        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i*4+j;
                if(state[ind]===state[ind+1])
                {
                    adj_score+=state[ind];
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }

        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i+j*4;
                if(state[ind]===state[ind+4])
                {
                    adj_score+=state[ind];
                    if(state[ind]===0)
                        zero_adj_num++;
                }
            }
        }


        // if(zero_adj_num>0)
        // {
        //     // score=Math.pow(score,zero_adj_num);
        //     score=score*Math.pow(1.2,zero_adj_num);

        // }

        score=score+adj_score;

        return score;
    }


    let evaluate_state_v2=(state)=>{
        // considers v1 and also considers adjaceny
        let score=0;
        for(let i=0;i<state.length;i++)
        {
            score+=Math.pow(state[i],2)
        }
        let adj_score=0;
        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i*4+j;
                if(state[ind]===state[ind+1])
                {
                    adj_score+=state[ind];
                }
            }
        }

        for(let i=0;i<4;i++)
        {
            for(let j=0;j<3;j++)
            {
                let ind=i+j*4;
                if(state[ind]===state[ind+4])
                {
                    adj_score+=state[ind];
                }
            }
        }

        score=score+adj_score;

        return score;
    }

    let evaluate_state_v1=(state)=>{
        //normal takes in score and powers it
        let score=0;
        for(let i=0;i<state.length;i++)
        {
            score+=Math.pow(state[i],2)
        }
        return score;
    }

    let simulate_add_extra_tile =(ns)=>{

        let v=get_random();
        let ns1=[...ns];
        let p=get_empty_pos(ns1);
        let ind2=Math.floor(Math.random()*p.length);
        let ind=p[ind2];
        ns1[ind]=v;
        return ns1;
    }

    let simulate_left=(ns1)=>{
        let num=ns1;
        let new_num=[];
        for(let i=0;i<4;i++)
        {
            let ind=i*4;
            let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];
          
            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                        row[k]=0;
                        break;
                    }   
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            for(let j=0;j<=3;j++)
            {
                if(non_zero_exists(row,j+1,3))
                {
                    while(row[j]==0)
                    {   
                        row=shift_left(row,j);
                    }
                }

            }
            new_num.push(row[0]);
            new_num.push(row[1]);
            new_num.push(row[2]);
            new_num.push(row[3]);
        }

        return new_num;
        let y1=simulate_add_extra_tile(new_num);
        // return y1;
      }

      let simulate_down = (ns1)=>{
        let num=ns1;
        let new_col=[];
        
        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];
            let copy_row=row;

            //merging part
            for(let j=3;j>0;j--)
            {
                for(let k=j-1;k>=0;k--)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                        row[k]=0;
                            // row=shift_right(row,k);
                        break;
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            for(let j=3;j>=0;j--)
            {
                if(non_zero_exists(row,0,j-1))
                {
                    while(row[j]==0)
                    {   
                        row=shift_right(row,j);
                    }
                }

            }
            for(let p=0;p<4;p++)
            new_col[p*4+ind]=row[p]

        }
        return new_col;
        let y1=simulate_add_extra_tile(new_col);
        return y1;
      }

      
    let simulate_right=(ns1)=>{

        let num=ns1;
        let new_num=[];
        for(let i=0;i<4;i++)
        {
            let ind=i*4;
            let row=[num[ind],num[ind+1],num[ind+2],num[ind+3]];

            //merging part
            for(let j=3;j>0;j--)
            {
                for(let k=j-1;k>=0;k--)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                        row[k]=0;
                        break;
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            for(let j=3;j>=0;j--)
            {
                if(non_zero_exists(row,0,j-1))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_right(row,j);
                    }
                }

            }
            new_num.push(row[0]);
            new_num.push(row[1]);
            new_num.push(row[2]);
            new_num.push(row[3]);
        }
        return new_num;
        let y1=simulate_add_extra_tile(new_num);
        return y1;
    
     }

    
    let simulate_up = (ns1)=>{
        let num=ns1;
        let new_col=[];
        for(let i=0;i<4;i++)
        {
            let ind=i;
            let row=[num[0*4+ind],num[ind+1*4],num[ind+2*4],num[ind+3*4]];
            let copy_row=row;
            

            //merging part
            for(let j=0;j<3;j++)
            {
                for(let k=j+1;k<=3;k++)
                {
                        if(row[j]===row[k] && row[j]!==0)
                    {
                        row[j]*=2;
                        row[k]=0;
                        break;
                    }
                    if(row[k]!=0)
                        break;
                }
            }


            //moving part
            // for(let j=3;j>=0;j--)
            for(let j=0;j<=3;j++)
            {
                if(non_zero_exists(row,j+1,3))
                {
                    while(row[j]==0)
                    {   
                        // console.log("asking in "+j);
                        row=shift_left(row,j);
                    }
                }

            }
            for(let p=0;p<4;p++)
                new_col[p*4+ind]=row[p]
        }

        return new_col;
        let y1=simulate_add_extra_tile(new_col);
        return y1;
     
    }


    let non_zero_exists=(A,bi,ind)=>{
        // non_zero_exists_less_than_index
          let flag=false;
          for(let i=bi;i<=ind;i++)
          {
              if(A[i]!=0)
              {
                    // console.log("non zero value:"+A[ind]+" index"+ind);
                  return true;
              }
          }
          return false;
      }

      let shift_right=(A,i)=>{
        //that index i is the stuff into ehich the first move takes place
        let B=A.slice();
        for(let k=i;k>0;k--)
        {
            B[k]=A[k-1]
        }
        B[0]=0;
        return B;
    }
    
    let shift_left=(A,i)=>{
        //that index i is the stuff into ehich the first move takes place
        let B=A.slice();
        for(let k=i;k<3;k++)
        {
            B[k]=A[k+1]
        }
        B[3]=0;
        return B;
    }

    let array_eq_check =(A,B)=>{
        return JSON.stringify(A)==JSON.stringify(B)
    }


    let result_down=(arr)=>{
        let arr1=[...arr];
        let b=simulate_down(arr1);
        // let frs=simulate_add_extra_tile(b);
        let frs=b;
        if(!array_eq_check(arr,b))
            frs=simulate_add_extra_tile(b);
        return frs;
    }
    let result_up=(arr)=>{
        let arr1=[...arr];
        let b=simulate_up(arr1);
        // let frs=simulate_add_extra_tile(b);
        let frs=b;
        if(!array_eq_check(arr,b))
            frs=simulate_add_extra_tile(b);
        return frs;
    }
    let result_right=(arr)=>{
        let arr1=[...arr];
        let b=simulate_right(arr1);
        let frs=b;
        if(!array_eq_check(arr,b))
            frs=simulate_add_extra_tile(b);
        return frs;
    }
    let result_left=(arr)=>{
        let arr1=[...arr];
        let b=simulate_left(arr1);
        // let frs=simulate_add_extra_tile(b);
        let frs=b;
        if(!array_eq_check(arr,b))
            frs=simulate_add_extra_tile(b);
        return frs;
    }



    let initial_logic=()=>{
        // original_state
                let present_state=[...original_state];
                let future_states=[];
                let temp_state=simulate_up(present_state);
                future_states.push(temp_state);
                temp_state=simulate_right(present_state);
                future_states.push(temp_state);
                temp_state=simulate_down(present_state);
                future_states.push(temp_state);
                temp_state=simulate_left(present_state);
                future_states.push(temp_state);


                let future_scores=[]
                let max_score=0;
                let best_dec=0;


                let future_with_random=[];
                for(let i=0;i<future_states.length;i++)
                {
                    let sc=evaluate_state(future_states[i])
                    let frs=simulate_add_extra_tile(future_states[i]);
                    future_with_random.push(frs);

                    future_scores.push(sc);
                    if(sc>=max_score && !array_eq_check(future_states[i], original_state))
                        {
                            best_dec=i;
                            max_score=sc;
                        }
                }
                
                console.log(present_state);
                console.log(future_states);
                console.log(future_scores);
                console.log(future_with_random);
                

                return best_dec;
    }

    class TreeNode {
    constructor(value,action,score) {
        this.value = value;
        this.descendants = [];
        this.parent = null;
        this.action=action;
        this.score=score;
    }

    add_child(node){
        this.descendants.push(node);
        if (node) {
            node.parent = this;
        }
    }

    }

    let score_psuedo=(arr,i,td,parent)=>{
        if(array_eq_check(arr,parent))
            return -10;
        // if(i===(td-1))
            return evaluate_state(arr);
        // return 0;

    }


    let heurisitic = ()=>{
        let debug=false;

        let present_state=[...original_state];
        console.log("nowth state");
        console.log(present_state);
        let generations=[];
        // generations.push(present_state);
        let total_depth=2;
        total_depth=5;
        let root=new TreeNode(present_state,-1,0);
        generations.push(root);

        for(let i=0;i<total_depth;i++)
        {
            let new_gen=[];
            for(let j=0;j<generations.length;j++)
            {
                // let item=generations[i];
                // root=item;

                root=generations[j];
                let item=root.value;
                
                let r1=result_up(item);
                let r2=result_right(item);
                let r3=result_down(item);
                let r4=result_left(item);

                // let pfact=0.9;
                // let parent_percentage_score=root.score*pfact;
                // let s1=new TreeNode(r1,0,score_psuedo(r1,i,total_depth,item)+parent_percentage_score);


                //the thing worked when it was 0.9
                let pfact=Math.pow(0.85,i);
                let parent_percentage_score=root.score;
                

                let s1=new TreeNode(r1,0,score_psuedo(r1,i,total_depth,item)*pfact+parent_percentage_score);
                let s2=new TreeNode(r2,1,score_psuedo(r2,i,total_depth,item)*pfact+parent_percentage_score);
                let s3=new TreeNode(r3,2,score_psuedo(r3,i,total_depth,item)*pfact+parent_percentage_score);
                let s4=new TreeNode(r4,3,score_psuedo(r4,i,total_depth,item)*pfact+parent_percentage_score);

                root.add_child(s1);
                root.add_child(s2);
                root.add_child(s3);
                root.add_child(s4);

                new_gen.push(s1);
                new_gen.push(s2);
                new_gen.push(s3);
                new_gen.push(s4);
            }
            generations=new_gen;
            console.log("depth at = "+i);
            if(debug)
                console.log(new_gen);
        }


        //find max score in generations
        //go (td-1) times parent
        //return that action

        let max_score=-100;
        let max_item;
        let max_index=-1;
        for(let i=0;i<generations.length;i++)
        {
            let a=generations[i].score;
            if(a>=max_score)
            {
                max_score=a;
                max_item=generations[i];
                max_index=i;
            }
        }

        let ans=max_item.action
        let local_moves=[];

        for(let i=1;i<=total_depth-1;i++)
        {
            local_moves.push(max_item.action);
            max_item=max_item.parent;
        }

        local_moves.push(max_item.action);

        let ACTION=["UP", "RIGHT","DOWN", "LEFT"];
        
        if(debug)
        {
            for(let i=local_moves.length-1;i>=0;i--)
            {
                let bird=local_moves[i];
                console.log(ACTION[bird]);
            }
        }


        if(debug)
        {
            console.log("max score= "+max_score);
            console.log("max index = "+max_index);
            console.log(generations.length);
            console.log(generations);
            console.log("present parent top level score= "+max_item.score);
        }


        //checking if infinte loop hole
        if(max_item.score===-10)
            console.log("bad situation with loop");
        else
            ans=max_item.action;


        console.log("this is heuristic = "+ans);
        return ans;

    }



    let h_ans=heurisitic();

            //this part to be only done if left is disabed and u want to do it only in case of a deadlock
    // let present_state_copy=[...original_state];
    // let present_state_ans;
    // if(h_ans==0)
    //     present_state_ans=result_up(present_state_copy);
    // if(h_ans==1)
    //     present_state_ans=result_right(present_state_copy);
    // if(h_ans==2)
    //     present_state_ans=result_down(present_state_copy);
    
    // if(array_eq_check(present_state_ans,present_state_copy))
    //     h_ans=3;
    
        // let il_ans=initial_logic();
    return h_ans;
    



}

export default Predict_2048
